module.exports = __webpack_public_path__ + "static/img/application-default.51340e82.png";